import React from 'react';
import { useStyles } from './device-menu-status-icon-styles';
import { ReactComponent as Unhealthy } from 'src/common/media/action-required.svg';
import { ReactComponent as Healthy } from 'src/common/media/notification.svg';

interface Props {
  operational?: boolean;
  className?: string;
}

const testIdPrefix = 'device-menu-status-icon';

const DeviceMenuStatusIcon: React.FC<Props> = (props: Props): JSX.Element => {
  const { operational, className: optionalClassName } = props;
  const classes = useStyles({ operational });
  const className = `${classes.root} ${optionalClassName}`;

  return operational ? (
    <Healthy data-testid={`${testIdPrefix}-healthy`} className={className} />
  ) : (
    <Unhealthy data-testid={`${testIdPrefix}-unhealthy`} className={className} />
  );
};

export default DeviceMenuStatusIcon;
